import React from 'react';
import { cn } from '@/lib/utils';
import { STACK_COLORS } from '@/lib/store';

export function SevenDayStrip({ history, colorName = 'crimson', size = 'default', showLabels = false }) {
    const color = STACK_COLORS.find(c => c.name === colorName) || STACK_COLORS[0];
    
    const sizeClasses = {
        small: 'w-3 h-3',
        default: 'w-5 h-5',
        large: 'w-7 h-7',
    };
    
    return (
        <div className="flex items-center gap-0.5">
            {history.map((day, index) => (
                <div key={day.date} className="flex flex-col items-center gap-0.5">
                    <div
                        className={cn(
                            "rounded-sm transition-all",
                            sizeClasses[size],
                            day.ran 
                                ? color.class 
                                : "bg-border",
                            day.isToday && !day.ran && "ring-1 ring-primary/50"
                        )}
                        title={`${day.date}: ${day.ran ? `${day.itemsCompleted}/${day.totalItems}` : 'Missed'}`}
                    />
                    
                    {showLabels && (
                        <span className={cn(
                            "text-[9px]",
                            day.isToday ? "text-primary font-medium" : "text-muted-foreground"
                        )}>
                            {day.dayOfWeek}
                        </span>
                    )}
                </div>
            ))}
        </div>
    );
}
